import { useState, useEffect,useRef,Fragment } from 'react';
import { useAuthLocalStorage } from '../moduls/useLocalStore';
import style from './popup.module.css';
import CustomCheckbox from '../moduls/customcheckbox';

function Popup({user,setUser,token,saveToken,removeToken,openPay}) {
   /*
    При отправке если email net - input border: 1px solid rgba(255, 0, 0, 1);
    Текст заголовок - Аккаунт не найден
    Текст снизу - *Проверьте написание e-mail и попробуйте сначала цвет завездочки #FF0000
   */

    const client_id = process.env.REACT_APP_CLIENT_ID;
    const client_yad = process.env.REACT_APP_CLIENT_YAD;
    const client_go = process.env.REACT_APP_CLIENT_GO;
    const redirect_uriv = "https://im-gpt.ru/api/vk";
    const redirect_uri = "https://im-gpt.ru/api/yandex";
    const redirect_urig = "https://im-gpt.ru/api/google";
    const ALLOWED_TYPES = [
        "image/png",
        "image/jpeg"
    ];
    // Сгенерировать PKCE code_verifier и code_challenge
    const code_verifier = generateUUID();
    localStorage.setItem('code_verifier', code_verifier);
    function generateUUID() {
        if (window.crypto && crypto.randomUUID) {
            return crypto.randomUUID();
        }
        // fallback для iOS
        return 'xxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    async function generateCodeChallenge(verifier) {
        const digest = await crypto.subtle.digest(
        "SHA-256",
        new TextEncoder().encode(verifier)
        );
        return btoa(String.fromCharCode(...new Uint8Array(digest)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
    }
    const loginVK = async () => {
        const code_challenge = await generateCodeChallenge(code_verifier);
        const state = crypto.randomUUID();
        localStorage.setItem('state', state);
        const scope = encodeURIComponent(
        'vkid.personal_info email phone'
        );
        const url = `https://id.vk.ru/authorize?response_type=code&client_id=${client_id}&device_id=${state}&redirect_uri=${encodeURIComponent(redirect_uriv)}&state=${state}&code_challenge=${code_challenge}&code_challenge_method=S256&scope=${scope}`;
        window.location.href = url;
    };
    const loginYA = async () => {
        const code_challenge = await generateCodeChallenge(code_verifier);
        const state = crypto.randomUUID();
        localStorage.setItem('state', state);

        const url = `https://oauth.yandex.ru/authorize?response_type=code&client_id=${client_yad}&redirect_uri=${encodeURIComponent(redirect_uri)}&state=${state}&code_challenge=${code_challenge}&code_challenge_method=S256`;
        window.location.href = url;
    };
    const loginGo = () => {
        const scope = encodeURIComponent(
        'openid email profile'
        );
        const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${client_go}&redirect_uri=${encodeURIComponent(
        redirect_urig
        )}&response_type=code&scope=${scope}&access_type=offline&prompt=consent`;

        window.location.href = authUrl;
    };
    const CheckEmail = (inp) => {
        const input = document.getElementById(inp);
        if (!input) return console.error(`Input #${inp} not found`);

        const email = input.value.trim(); // получаем email из инпута
        if (!email) return console.error("Email пустой");

        const utm = localStorage.getItem("utm_source");
        fetch("https://im-gpt.ru:3000/api/checkaccount", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email,utm }),
        })
        .then(res => res.json())
        .then(data => {
       
            if(data?.token) 
            {
                saveToken(data.token);
                window.ym(96157357,'reachGoal','2');
            }
        })
        .catch(err => console.error(err));
    };
    const LoginEmail = () => {
        const errorid = document.getElementById('errorlogin');
        errorid.textContent = '';
        const input = document.getElementById('emaillogin');
        if (!input) return  console.error(`Input #pass not found`);

        const email = input.value.trim(); // получаем email из инпута
        if (!email) return  errorid.textContent= `Email пустой`;

        const passinput = document.getElementById('pass');
        if (!passinput) return console.error(`Input #pass not found`);

        const pass = passinput.value.trim(); // получаем email из инпута
        if (!pass) return errorid.textContent= `Пароль пустой`;

        fetch("https://im-gpt.ru:3000/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email,pass }),
        })
        .then(res => res.json())
        .then(data => {

            if(data?.token) saveToken(data.token);
            else if(data?.error) errorid.textContent= data.error;
            
        })
        .catch(err => console.error(err));
    };

    const [tokens, setTokens] = useState(10000);
    const [sum, setSum] = useState(17);
    const limitsRef = useRef(null);
    const checkRef = useRef(null);
    const limitsRefz = useRef(null);
    const checkRefz = useRef(null);
    const [maxHeight, setMaxHeight] = useState("auto");

    useEffect(() => {
        if(user.popup === 5)
        {
            const screenWidth = window.innerWidth;

            if (screenWidth <= 600 && limitsRef.current && checkRef.current) {
                const limitsTop = limitsRef.current.getBoundingClientRect().top;
                const checkTop = checkRef.current.getBoundingClientRect().top;

                // вычисляем высоту до верха <p>чек</p>
                const height = checkTop - limitsTop;
                setMaxHeight(height);
            } else {
                setMaxHeight("none");
            }
        }
        else if(user.popup === 6)
        {
            const screenWidth = window.innerWidth;

            if (screenWidth <= 600 && limitsRefz.current && checkRefz.current) {
                const limitsTop = limitsRefz.current.getBoundingClientRect().top;
                const checkTop = checkRefz.current.getBoundingClientRect().top;

                // вычисляем высоту до верха <p>чек</p>
                const height = checkTop - limitsTop;
                setMaxHeight(height);
            } else {
                setMaxHeight("none");
            }
        }
    }, [user.popup]); // пустой массив зависимостей — выполнится только при первом рендере

   function formatUnixTime(unixTime) {
        const date = new Date(unixTime * 1000); // unixTime в секундах → умножаем на 1000

        const dd = String(date.getDate()).padStart(2, '0');
        const mm = String(date.getMonth() + 1).padStart(2, '0'); // месяцы с 0
        const yy = String(date.getFullYear()).slice(-2); // последние 2 цифры года

        const hh = String(date.getHours()).padStart(2, '0');
        const min = String(date.getMinutes()).padStart(2, '0');
        const ss = String(date.getSeconds()).padStart(2, '0');

        return `${dd}.${mm}.${yy} ${hh}:${min}:${ss}`;
    }

    const rate = 599 / 350000;
    const minSum = 5;   

    function handleTokensChange(e) {
        const value = e.target.value.replace(/\D/g, ""); // оставляем только цифры
        setTokens(value);

        if (value) {
        let calculatedSum = Math.round(Number(value) * rate);
        if (calculatedSum < minSum) calculatedSum = minSum; // минимальная сумма
        setSum(calculatedSum.toLocaleString("ru-RU"));
        } else {
        setSum("");
        }
    }
    function changePopup(id) {
        setUser(prev => ({
            ...prev,
            popup: id,
        }));
    }
    const [tempUser, setTempUser] = useState(user);
    
    useEffect(() => {
         if (user.popup !== 1) {
            setTempUser(user);
         }
    }, [user]);
    let content = null;
    const saveUser = async () => {
        if(tempUser.name.length < 2){
            changePopup(0);
            return false;
        }
        const resz = await fetch("https://im-gpt.ru:3000/api/updateName", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ name: tempUser.name })
        });
        const onload = await resz.json();
        if(onload.confirm)
        {
             setUser(prev => ({
                ...prev,
                name: tempUser.name, // ✅ ТОЛЬКО имя
                popup: 0,
            }));
        }
    }
    function getRequiredValue(id, label = id) {
        const input = document.getElementById(id);
        if (!input) {
            console.error(`Input #${id} not found`);
            return null;
        }

        input.style.border = '';
        input.style.outline = '';

        const value = input.value.trim();
        if (!value) {
            console.error(`${label} пустой`);
            input.style.border = '1px solid red';
            input.style.outline = 'none';
            input.focus();
            return null;
        }

        return value;
    }
    const RestorePassword = async () => {
        const email  = getRequiredValue('emailrestore', 'EMAIL');
        if (![email].every(Boolean)) return;
       

        fetch("https://im-gpt.ru:3000/api/restorePassword", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email }),
            })
            .then(res => res.json())
            .then(data => {
                if(data.error) return alert(data.error);
                else changePopup(9);
                    
                
            })
        .catch(err => console.error(err));
        //setState(true)
    }
    const [displayIndex, setDisplayIndex] = useState(4);
    function getActiveMenuIndex() {
        if (displayIndex === 0) return 0;
        if (displayIndex === 4 || displayIndex === 5) return 1;
        return 2;
    }
    const UnSub = async () => {
        const resz = await fetch("https://im-gpt.ru:3000/api/unsub", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }
        });
        const onload = await resz.json();
        if(onload.confirm) setDisplayIndex(3);
        
    }
    function logout(){
        removeToken();
        changePopup(0);
        
    }
    const photoInputRef = useRef(null);
    const hanglePhotoChange = async (e) => {
        const files = e.target.files;

        if (!files || files.length === 0) return;

        // Ограничение: 1 файл
        if (files.length > 1) {
            alert("Можно прикрепить не более 1 файла");
            e.target.value = "";
            return;
        }

        const selectedFiles = files[0];
        // Проверка типа файла
            if (!ALLOWED_TYPES.includes(selectedFiles.type)) {
            alert(`Файл "${selectedFiles.name}" не поддерживается`);
            return;
        }

            // Проверка размера одного файла
        if (selectedFiles.size > (10 * 1024 * 1024)) {
            alert(`Файл "${selectedFiles.name}" слишком большой (макс 10 MB)`);
            return;
        }
        const formData = new FormData();
        formData.append("file", selectedFiles);
        const res = await fetch("https://im-gpt.ru:3000/api/upload", {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        });

        const data = await res.json();
        if (data.uploaded) {
             const resz = await fetch("https://im-gpt.ru:3000/api/updatePhoto", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ url: data.url })
            });
            const onload = await resz.json();
            if(onload.confirm)
            {
                setUser(prev => ({
                    ...prev,
                    pic: data.url}));
            }
        }

            

        // Сброс input
        e.target.value = "";
        };
        const h1 = localStorage.getItem("h1") || "Нейросеть I’m-GPT за 1₽";
    switch (user.popup) {    
    case 1:
        content = (<div className={style.popupblock}>
            <div className={style.popup}>
                <div className={style.flextop}>
                    <h3>Мой профиль</h3>
                </div>
                <div className={style.flexprofile}>
                    <div className={style.blockphoto} style={{backgroundImage: `url(${user.pic || 'img/nopic.png'})`}}>
                        <img src='img/change.png' alt='change'  onClick={() => photoInputRef.current.click()}/>
                        <input
                                type="file"
                                ref={photoInputRef}
                                hidden
                                accept="
                                    image/png,
                                    image/jpeg
                                   "
                                onChange={hanglePhotoChange}
                            />
                    </div>
                    <h4>Здесь Вы можете поменять данные профиля</h4>
                </div>
               <div className={`${style.field} ${user.name ? style.filled : ''}`}>
                    <input
                        type="text"
                        id="name"
                        value={tempUser.name}
                        onChange={e =>
                            setTempUser(prev => ({
                                ...prev,
                                name: e.target.value,
                            }))
                        }
                        required
                    />
                    <label htmlFor="name">Отображаемое имя</label>
                </div>
                <div className={`${style.field} ${user.email ? style.filled : ''}`}>
                    <input
                        type="text"
                        id="login"
                        readOnly
                        value={user.email}
                        required
                    />
                    <label htmlFor="login">Логин пользователя</label>
                </div>
                <div className={style.flexbtn}>
                    <button className={style.btncolor} onClick={saveUser}>Сохранить</button>
                    <button className={style.btn} onClick={() => changePopup(0)}>Отменить</button>
                </div>
                
            </div>
        </div>);
         break;
         case 2:
            content = (
                <div className={style.popupblock}>
                    <div className={style.popupfloat}>
                        <div className={style.topfloat}>
                            <h3>Настройки</h3>
                            <img src='img/closepopup.png' className={style.closepopup} onClick={() => changePopup(0)} alt='close'/>
                        </div>
                        <ul className={style.scrollmenu}>
                            <li
                                className={getActiveMenuIndex() === 0 ? style.active : ''}
                                onClick={() => setDisplayIndex(0)}
                            >
                                Профиль
                            </li>

                            <li
                                className={getActiveMenuIndex() === 1 ? style.active : ''}
                                onClick={() => setDisplayIndex(4)}
                            >
                                Токены
                            </li>

                            <li
                                className={getActiveMenuIndex() === 2 ? style.active : ''}
                                onClick={() => setDisplayIndex(1)}
                            >
                                Управление
                            </li>
                        </ul>

                        <div className={style.displays}>
                            {displayIndex === 0 && (
                                <div className={style.display}>
                                    <p>Имя</p>
                                    <h4>{user.name}</h4>
                                    <hr/>
                                    <p>E-mail</p>
                                    <h4>{user.email}</h4>
                                    <hr/>
                                    <p>Пароль</p>
                                    <h4>{user.password}</h4>
                                    <hr className={style.mb30}/>
                                    <button className={style.exitacc} onClick={() => changePopup(4)}>Выйти из профиля</button>
                                </div>
                            )}
                            {displayIndex === 1 && (
                                <div className={style.display}>
                                    <h3>Дата регистрации: <span>{formatUnixTime(user.timesub)}</span></h3>
                                    <h3>Статус подписки: <span>{user.sub > 0 ? 'Активна' : 'Не активна'}</span></h3>
                                    {user.sub > 0 && <h3>Дата следующей оплаты: <span>{formatUnixTime(user.nextpay)}</span></h3>}
                                    {user.sub > 0 && <h3>Управление подпиской:</h3>}
                                    {user.sub > 0 && <button className={style.unsub} onClick={() => setDisplayIndex(2)}>Отменить подписку</button>}
                                </div>
                            )}
                            {displayIndex === 2 && (
                                <div className={style.display}>
                                    <h2>Вы уверены что хотите отменить подписку?</h2>
                                    <h5>Доступ к чату будет доступен до момента пока не кончатся оплаченные токены</h5>
                                    <div className={style.flexbtn}>
                                        <button className={style.back} onClick={() => changePopup(0)}>Остаться</button>
                                        <button className={style.uns} onClick={() => UnSub(3)}>Отменить подписку</button>
                                    </div>
                                </div>
                            )}
                            {displayIndex === 3 && (
                                <div className={`${style.display}`}>
                                    <h2>Подписка успешно отключена!</h2>
                                    <h5>Доступ к чату будет доступен до момента пока не кончатся оплаченные токены</h5>
                                    <div className={style.flexbtn}>
                                        <button className={style.uns} onClick={() => changePopup(0)}>Вернуться в чат</button>
                                    </div>
                                </div>
                            )}
                            {displayIndex === 4 && (
                                <div className={`${style.display}`}>
                                    <h3>Доступно токенов в тарифе: <span>350 000</span></h3>
                                    <h3>Осталось токенов: <span>{user.token}</span></h3>
                                    <div className={style.flexbtn}>
                                        <button className={style.addtokens} onClick={() => setDisplayIndex(5)}>Добавить токены</button>
                                    </div>
                                </div>
                            )}
                            {displayIndex === 5 && (
                                <div className={`${style.display}`}>
                                    <h6>Добавить токены:</h6>
                                    <h5>Введите нужное количество токенов и нажмите кнопку “Добавить токены”</h5>
                                    <div className={`${style.field}`}>
                                    <input
                                            type="text"
                                            id="tokens"
                                            value={tokens}
                                            onChange={handleTokensChange}
                                            required
                                        />
                                        <label htmlFor="tokens">Кол-во токенов</label>
                                    </div>
                                    <div className={`${style.field} ${style.filled}`}>
                                        <input
                                            type="text"
                                            id="sum"
                                            
                                            value={sum ? `${sum} ₽` : ""}
                                            readOnly
                                            required
                                        />
                                        <label htmlFor="sum">Сумма к оплате</label>
                                    </div>
                                    <div className={style.flexbtn}>
                                        <button className={style.addtokens} onClick={() => openPay(user.email,user.id,sum)}>Добавить токены</button>
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            );
            break;
         case 3:
            content = (
                <div className={style.popupblock}>
                    <div className={style.popupfloat}>
                        <div className={style.topfloat}>
                            <h3>Поддержка I’m-GPT </h3>
                            <img src='img/closepopup.png' className={style.closepopup} onClick={() => changePopup(0)} alt='close'/>
                        </div>
                        <div className={style.pdp}>По всем вопросам</div>
                        <div className={`${style.pdh3} ${style.mb25}`}>im-gpt.ru@yandex.ru</div>
                        <div className={style.pdp}>Время работы</div>
                        <div className={`${style.pdh3}`}>Понедельник - Пятница</div>
                        <div className={`${style.pdh3}`}>10:00 - 17:00</div>
                        
                    </div>
                </div>
                        );
            break;
        case 4:
            content = (
                <div className={style.popupblock}>
                    <div className={style.popup}>
                        <div className={style.poph3}>
                            Вы уверены что хотите выйти из профиля?
                        </div>
                        <div className={style.poppp}>
                            Покидая профиль при попытки входа Вам придется авторизовываться заново
                        </div>
                        <div className={style.flexbtn}>
                            <button className={`${style.btncolor} ${style.minbtn}`} onClick={() => changePopup(0)}>Остаться</button>
                            <button className={`${style.btn} ${style.maxbtn}`} onClick={logout}>Выйти из профиля</button>
                            
                        </div>
                        
                    </div>
                </div>
                        );
            break;
        case 5:
            content = (
                <div className={style.popupblock}>
                    <div className={`${style.popup} ${style.scrollable}`} ref={limitsRef} style={{ maxHeight: maxHeight, overflowY: maxHeight !== "none" ? "auto" : "visible" }}>
                        <div className={style.flextop}>
                            
                            <h3>
                            {h1.split(/<br\s*\/?>/i).map((text, index) => (
                                <Fragment key={index}>
                                {index > 0 && <br />}
                                {text}
                                </Fragment>
                            ))}
                            </h3>
                            <img src='img/closepopup.png' className={style.closepopup} onClick={() => changePopup(0)} alt='close'/>
                        </div>
                        <p className={style.podzagal}>Что Вы получите:</p>
                        <p className={style.plusz}><span>✓</span>Создание изображений</p>
                        <p className={style.plusz}><span>✓</span>Генерации из ваших фото</p>
                        <p className={`${style.plusz} ${style.mb15}`}><span>✓</span>Нейросеть для любых задач</p>
                        <div className={`${style.field}`}>
                            <input
                                type="text"
                                id="email"
                                required
                            />
                            <label htmlFor="email">Введите e-mail</label>
                        </div>
                        <button className={`${style.btncolor} ${style.unlimit}`} onClick={() => CheckEmail('email')}>Купить за 1₽</button>
                        <div className={style.flexfast}>
                            <div className={style.btnfast} onClick={loginVK}>
                                <img src='img/vk.png' alt='vk'/>
                            </div>
                            <div className={style.btnfast} onClick={loginYA}>
                                <img src='img/yandex.png' alt='yandex'/>
                            </div>
                            <div className={style.btnfast} onClick={loginGo}>
                                <img src='img/google.png' alt='google'/>
                            </div>
                        </div>
                        <p ref={checkRef} className={style.mt25}></p>
                        <CustomCheckbox label={<>Нажимая кнопку «Попробовать сейчас за 1₽» или используя другие способы регистрации, я соглашаюсь с <a href="docs/public_offer.pdf" target="_blank" rel="noopener noreferrer">публичной офертой</a> и даю согласие <a href="docs/processing.pdf" target="_blank" rel="noopener noreferrer">на обработку данных</a></>}/>
                        <CustomCheckbox label={<>Нажимая кнопку «Попробовать сейчас за 1₽» или используя другие способы регистрации, я согласен на автоматическую оплату в размере 599 рублей по истечению 7 дней пробного периода, а также каждые 30 дней до момента отмены подписки</>}/>
                    </div>
                </div>
            );
            break;
            case 6:
            content = (
                <div className={style.popupblock}>
                    <div className={`${style.popup} ${style.scrollable}`} ref={limitsRefz} style={{ maxHeight: maxHeight, overflowY: maxHeight !== "none" ? "auto" : "visible" }}>
                        <div className={style.flextop}>
                            <h3>Доступ всего за 1₽*</h3>
                            <img src='img/closepopup.png' className={style.closepopup} onClick={() => changePopup(0)} alt='close'/>
                        </div>
                        <p className={style.popupsp}>Промокоды от I’m-GPT нейросеть которая помогает экономить</p>
                        <div className={`${style.field}`}>
                            <input
                                type="text"
                                id="emailz"
                                required
                            />
                            <label htmlFor="emailz">Введите e-mail</label>
                        </div>
                        <button className={`${style.btncolor} ${style.unlimit}`} onClick={() => CheckEmail('emailz')}>Получить доступ</button>
                        <div className={style.flexfast}>
                            <div className={style.btnfast} onClick={loginVK}>
                                <img src='img/vk.png' alt='vk'/>
                            </div>
                            <div className={style.btnfast} onClick={loginYA}>
                                <img src='img/yandex.png' alt='yandex'/>
                            </div>
                            <div className={style.btnfast} onClick={loginGo}>
                                <img src='img/google.png' alt='google'/>
                            </div>
                        </div>
                        <p ref={checkRefz} className={style.mt25}></p>
                        <CustomCheckbox label={<>*Нажимая кнопку «Попробовать сейчас за 1₽» или используя другие способы регистрации, я соглашаюсь с <a href="docs/public_offer.pdf" target="_blank" rel="noopener noreferrer">публичной офертой</a> и даю согласие <a href="docs/processing.pdf" target="_blank" rel="noopener noreferrer">на обработку данных</a></>}/>
                        <CustomCheckbox label={<>*Нажимая кнопку «Попробовать сейчас за 1₽» или используя другие способы регистрации, я согласен на автоматическую оплату в размере 599 рублей по истечению 7 дней пробного периода, а также каждые 30 дней до момента отмены подписки</>}/>
                    </div>
                </div>
            );
            break;
        case 7:
            content = (
                <div className={style.popupblock}>
                    <div className={`${style.popup}`}>
                        <div className={style.flextop}>
                            <h3>Авторизация</h3>
                            <img src='img/closepopup.png' className={style.closepopup} onClick={() => changePopup(0)} alt='close'/>
                        </div>
                        <p className={style.popupsp}>Введите данные от Вашего аккаунта на I’m-GPT </p>
                        <div className={`${style.field}`}>
                            <input
                                type="text"
                                id="emaillogin"
                                required
                            />
                            <label htmlFor="emaillogin">Введите e-mail</label>
                        </div>
                        <div className={`${style.field}`}>
                            <input
                                type="text"
                                id="pass"
                                required
                            />
                            <label htmlFor="pass">Введите пароль</label>
                        </div>
                        <p id="errorlogin" className={style.errorin}></p>
                        <button className={`${style.btncolor} ${style.unlimit}`} onClick={() => LoginEmail()}>Войти в аккаунт</button>
                        <div className={style.flexfast}>
                            <div className={style.btnfast} onClick={loginVK}>
                                <img src='img/vk.png' alt='vk'/>
                            </div>
                            <div className={style.btnfast} onClick={loginYA}>
                                <img src='img/yandex.png' alt='yandex'/>
                            </div>
                            <div className={style.btnfast} onClick={loginGo}>
                                <img src='img/google.png' alt='google'/>
                            </div>
                        </div>
                        <div className={style.restorebtn} onClick={() => changePopup(8)}>Восстановить пароль</div>
                    </div>
                </div>
            );
            break;
        case 8:
            content = (
                <div className={style.popupblock}>
                    <div className={`${style.popup}`}>
                        <div className={style.flextop}>
                            <h3 id='editbigerror'>Восстановление пароля</h3>
                            <img src='img/closepopup.png' className={style.closepopup} onClick={() => changePopup(0)} alt='close'/>
                        </div>
                        <p id='editminerror' className={style.popupsp}>Введите e-mail с которого была совершена регистрация </p>
                        <div className={`${style.field}`}>
                            <input
                                type="text"
                                id="emailrestore"
                                required
                            />
                            <label htmlFor="emailrestore">Введите e-mail</label>
                        </div>
                        
                        <button className={`${style.btncolor} ${style.unlimit}`} onClick={() => RestorePassword()}>Восстановить</button>
                        <div className={style.restorebtn} onClick={() => changePopup(7)}>Я знаю пароль</div>
                    </div>
                </div>
            );
            break;
        case 9:
            content = (
                <div className={style.popupblock}>
                    <div className={`${style.popup}`}>
                        <div className={style.flextop}>
                            <h3>Новый пароль создан!</h3>
                            <img src='img/closepopup.png' className={style.closepopup} onClick={() => changePopup(0)} alt='close'/>
                        </div>
                        <p className={style.popupsp}>Пароль был успешно изменен, мы отправили пароль на вашу электронную почту</p>
                        
                        
                        <button className={`${style.btncolor} ${style.unlimit}`} onClick={() => changePopup(7)}>Войти в аккаунт</button>
                    </div>
                </div>
            );
            break;
        default: content = null;
    }
  return content;
}

export default Popup;
